/** Release 3 REV-1 — top-bar bell with the unread count; toggles the inbox panel. */
import { useEffect, useRef, useState } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '@/lib/api/queries';
import { useSessionStore } from '@/stores/session';
import { IconButton } from '@/components/Button';
import { NotificationsPanel } from './NotificationsPanel';

export function NotificationBell() {
  const wsId = useSessionStore((s) => s.workspace?.id);
  const q = useNotifications(wsId);
  const unread = q.data?.pages[0]?.unread_count ?? 0;
  const [open, setOpen] = useState(false);
  const wrap = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (wrap.current && !wrap.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  const label = unread > 0 ? `Notifications, ${unread} unread` : 'Notifications';
  return (
    <div ref={wrap} className="relative">
      <IconButton label={label} active={open} aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(!open)} data-notification-bell className="relative">
        <Bell size={16} />
        {unread > 0 && (
          <span data-bell-count className="absolute -top-0.5 -right-0.5 min-w-4 rounded-full bg-accent px-1 text-center text-[10px] leading-4 font-semibold text-white">
            {unread > 99 ? '99+' : unread}
          </span>
        )}
      </IconButton>
      {open && (
        <div className="absolute top-full right-0 z-40 mt-1">
          <NotificationsPanel onClose={() => setOpen(false)} />
        </div>
      )}
    </div>
  );
}
